module.exports = __webpack_public_path__ + "img/icon-attachment-gray.eb9453ed.svg";